// extracted by mini-css-extract-plugin
export default {"record_txt":"index_record_txt_-Yh1P","newsSpec":"index_newsSpec_AbnFe","current":"index_current_VRAFA"};